<div class="custom-control custom-checkbox">
  <input type="checkbox" class="custom-control-input" [id]="elementId" [(ngModel)]="isChecked" [disabled]="disabled" (ngModelChange)="isCheckedChange.emit(isChecked)">
  @if (label) {
    <label class="custom-control-label" [for]="elementId">
      {{ label }}
    </label>
  }
  @if (!label) {
    <label class="custom-control-label" [for]="elementId">
      <ng-content></ng-content>
    </label>
  }
</div>

